import { commonjsGlobal as f } from "../../../_virtual/_commonjsHelpers.js";
import { __exports as s } from "../../../_virtual/expiration-date.js";
import "./lib/parse-date.js";
import "./expiration-month.js";
import "./expiration-year.js";
import { __exports as m } from "../../../_virtual/parse-date.js";
import { __exports as u } from "../../../_virtual/expiration-month.js";
import { __exports as d } from "../../../_virtual/expiration-year.js";
var l = f && f.__assign || function() {
  return l = Object.assign || function(t) {
    for (var e, r = 1, i = arguments.length; r < i; r++) {
      e = arguments[r];
      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, l.apply(this, arguments);
};
Object.defineProperty(s, "__esModule", { value: !0 });
s.expirationDate = void 0;
var _ = m, y = u, x = d;
function n(t, e, r, i) {
  return {
    isValid: t,
    isPotentiallyValid: e,
    month: r,
    year: i
  };
}
function h(t, e) {
  var r;
  if (typeof t == "string")
    t = t.replace(/^(\d\d) (\d\d(\d\d)?)$/, "$1/$2"), r = (0, _.parseDate)(String(t));
  else if (t !== null && typeof t == "object") {
    var i = l({}, t);
    r = {
      month: String(i.month),
      year: String(i.year)
    };
  } else
    return n(!1, !1, null, null);
  var a = (0, y.expirationMonth)(r.month), o = (0, x.expirationYear)(r.year, e);
  if (a.isValid) {
    if (o.isCurrentYear) {
      var p = a.isValidForThisYear;
      return n(p, p, r.month, r.year);
    }
    if (o.isValid)
      return n(!0, !0, r.month, r.year);
  }
  return a.isPotentiallyValid && o.isPotentiallyValid ? n(!1, !0, null, null) : n(!1, !1, null, null);
}
s.expirationDate = h;
export {
  s as default
};
